import { lapsedLabel, lapsedSeverityKey } from "./analyticsFormat";

// 0024/0025: the actionable agent table — assigned customers who lapsed (>30 days) or never
// ordered. Red-accented region; each row carries a severity badge that escalates by age
// (amber 30-59 → orange 60-89 → red 90+/never).
const LapsedCustomersTable = ({ rows }) => (
  <div className="analyticsTableCard analyticsTableCard--red">
    <h3 className="analyticsCardTitle">לקוחות לא פעילים (30+ ימים)</h3>
    {!rows || rows.length === 0 ? (
      <p className="analyticsEmpty">כל הלקוחות פעילים — אין למי לפנות 🎉</p>
    ) : (
      <table className="analyticsTable">
        <thead>
          <tr>
            <th>לקוח</th>
            <th>הזמנה אחרונה</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.customerId}>
              <td>{r.name}</td>
              <td>
                <span className={`lapsedBadge lapsedBadge--${lapsedSeverityKey(r.daysSinceLastOrder)}`}>
                  {lapsedLabel(r.daysSinceLastOrder)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default LapsedCustomersTable;
